<template>
  <div class="w-full">
    <div
      class="relative border-1 rounded-2xl min-w-full min-h-[110vh] md:min-h-[50vh] lg:min-h-[110vh] 2xl:min-h-[90vh] flex flex-col px-2 pt-[75px] laptop:pt-6 tablet:pt-5 pb-5 border-gray-300 bg-[#FFFFFF80]">
      <div
        class="mobile:left-0 mx-auto flex flex-col-reverse tablet:flex-row justify-between items-center gap-2.5 tablet:gap-2 absolute -top-6 right-0 tablet:left-auto w-full px-2.5 laptop:px-[15px]">
        <div
          class="w-full tablet:w-2/3 laptop:w-3/5 largeDesktop:w-1/2 flex flex-col-reverse tablet:flex-row gap-[10px] tablet:gap-[15px]">
          <div
            class="relative w-full desktop:w-4/5 largeDesktop:w-2/3 flex items-center justify-between !rounded-full 2xl:!rounded-full overflow-hidden border !border-customGray h-max pl-[2px] pr-[10px] bg-[#fff] shadow-[0px_0px_10px_0px_#00000026]">
            <span
              class="px-[20px] rounded-full font-poppins font-normal text-[14px] hidden laptop:flex items-center min-w-max h-[36px] text-[#fff] bg-[#F5B134]">Date
              Created</span>
            <div class="flex mobile:justify-between items-center w-full laptop:w-auto">
              <dateRangePicker ref="datePicker" v-model="selectedDate" :value="selectedDate" :disable-future="true"
                @change="onDateChange"
                input-class="!p-[10px] laptop:!px-[5px] 2xl:!px-0 2xl:!py-[0px] !text-[14px] !h-[40px] date-picker mx-input cursor-pointer  focus:outline-none laptop:w-[175px] largeDesktop:w-[173px] border-0" />
              <img src="../../assets/images/calendar-icon.svg" alt="Calendar Icon" @click="openDatePicker"
                @mousedown.stop class="w-[26px] h-[26px] object-contain cursor-pointer">
            </div>
          </div>
        </div>
        <div
          class="mobile:w-full right-0 mobile:left-0 laptop:w-4/5 desktop:w-3/5 largeDesktop:w-3/6 mx-auto flex tablet:justify-end items-center gap-2 tablet:left-auto">
          <entities :modelValue="limit" @update:modelValue="onLimitChange" globalEntitiesClass="'tablet:w-[45%]'" />
          <searchInput :globalSearchClass="'mobile:w-full tablet:!w-[55%]'"
            :input-class="'rounded-full shadow-[0px_0px_10px_0px_#00000026] pl-3 pr-16 py-3 w-full h-10 bg-white disabled:!bg-white disabled:opacity-100 focus:outline-none font-Poppins text-[14px] placeholder:text-[#999999]'"
            :buttonclass="'absolute top-1.5 right-1 w-7 h-7'" :img-src="require('@/assets/images/search-icon-01.png')"
            :clearClass="'absolute top-0 flex items-center justify-center !h-[100%] right-[2.2rem] laptop:w-4 laptop:h-4 largeDesktop:w-6 largeDesktop:h-6'"
            v-model="search" @input="onSearch" :onClear="onClearSearch" :readonly="loading" :clearable="true" />
        </div>
      </div>
      <div>
        <div class="block laptop:hidden">
          <div v-if="tableItems.length > 0" class="mt-2 min-h-[50vh]">
            
            <workOrderHistoryList v-for="(item, index) in tableItems" :key="index" :ref="'row-' + index"
      :item="item"
      :index="index"
      :isTooltipActive="activeTooltipIndex === index"
    @tooltip-toggled="handleTooltipToggled"
              @update="onActionClicked" />
          </div>
          <div v-else>
            <h6
              class="flex justify-center items-center font-poppins text-[20px] laptop:text-[30px] min-h-[60vh] 2xl:min-h-[80vh] mx-autoflex lg:justify-center font-poppins break-words m-0 text-[#333333]"
              v-if="tableItems == null || (tableItems && tableItems.length == 0)">
              No Record Found
            </h6>
          </div>
        </div>
      </div>
      <div class="mt-2 laptop:block hidden">
        <workOrderHistoryTable :tableHeaders="tableHeaders" :tableData="tableItems" :sortClicked="sortClicked"
          @update="onActionClicked" />
      </div>
    </div>
    <div v-if="tableItems && tableItems.length > 0"
      class="flex mobile:flex-col tablet:flex-row mobile:gap-3 tablet:gap-0 items-center justify-between relative -top-5 px-3">
      <paginationEntries class="mobile:hidden tablet:block" :currentPage="page" :perPage="limit"
        :totalItems="totalItems" />
      <customPagination :page="page" :total_pages="total_pages" :updatePage="updatePage" />
    </div>
    <cancelClaimModal ref="cancelClaimModal" @cancelled="refreshList" />
    <resheduleApptModal ref="resheduleApptModal" @cancelled="refreshList" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import entities from "../../components/showEntities/entities.vue";
import searchInput from '../../components/partialComponent/customInput.vue';
import workOrderHistoryTable from './workOrderHistoryTable.vue';
import workOrderHistoryList from './workOrderHistoryList.vue';
// import createQoute from "../../components/createQuote/createQuote.vue";
import customPagination from "../../components/partialComponent/customPagination.vue";
import paginationEntries from "../../components/partialComponent/pagination-entries.vue";
import dateRangePicker from "../../components/partialComponent/DateRangePicker.vue";
import cancelClaimModal from "../../components/cancelClaim/cancelClaimModal.vue";
import resheduleApptModal from "../../components/cancelClaim/resheduleApptModal.vue";
import moment from "moment";
import { param } from "jquery";

export default {
  components: {
    entities,
    searchInput,
    workOrderHistoryTable,
    // createQoute,
    customPagination,
    paginationEntries,
    workOrderHistoryList,
    dateRangePicker,
    cancelClaimModal,
    resheduleApptModal
  },
  data() {
    return {
      limit: 25,
      search: "",
      page: 1,
      total_pages: 0,
      totalItems: 0,
      debounceTimer: null,
      loading: false,
      tableHeaders: [],
      tableItems: [],
      selectedSort: {
        "column": "job_number",
        "direction": "DESC"
      },
      planDetails: null,
      selectedDate: this.getYearToDate(),
      activeTooltipIndex: null,
    }
  },
  computed: {
    ...mapGetters([
      "workOrderListing",
    ]),
  },
  watch: {
    workOrderListing: function (data) {
      this.loading = false
      this.tableItems = this.workOrderListing.body
      this.total_pages = this.workOrderListing.paging.total_pages
      this.totalItems = this.workOrderListing.paging.total_records
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },

  },
  mounted() {
    this.setTableHeaders();
    this.loading = true
    this.getWorkOrderListing({
      "search": this.search,
      "limit": this.limit,
      "page": this.page,
      date_range: `${this.selectedDate[0]} - ${this.selectedDate[1]}`
    });

    const container = document.getElementById('scrollContainer');
    if (container) {
      container.addEventListener('scroll', this.hideDatePicker, true);
    } else {
      console.warn('scrollContainer not found by ID');
    }
    const width = window.innerWidth;

    if (width >= 1200 && width <= 1400) {
        document.body.style.overflow = "hidden";
    }
  },
  beforeUnmount() {
    const container = document.getElementById('scrollContainer');
    if (container) {
      container.removeEventListener('scroll', this.hideDatePicker, true);
    }
  },
  methods: {
    ...mapActions([
      "getWorkOrderListing",
    ]),
    async refreshList() {
      await this.getWorkOrderListing({
        "search": this.search,
        "limit": this.limit,
        "page": this.page,
        date_range: `${this.selectedDate[0]} - ${this.selectedDate[1]}`
      });
    },
    getYearToDate() {
      return [
        moment().startOf("year").format("MM/DD/YYYY"),
        moment().format("MM/DD/YYYY")
      ];
    },
    handleTooltipToggled(index) {
      // Close previously open tooltip if a different row is clicked
       this.activeTooltipIndex =
        this.activeTooltipIndex === index ? null : index;
    },
    onDateChange(data) {
      this.page = 1
      this.selectedDate = data.dates,
        this.getWorkOrderListing({
          "search": this.search,
          "limit": this.limit,
          "page": this.page,
          date_range: `${this.selectedDate[0]} - ${this.selectedDate[1]}`
        });
      // this.getCommissionsList(this.getRequestParams())
    },
    openDatePicker() {
      if (this.$refs.datePicker) {
        this.$refs.datePicker.openDatePicker();
      }
    },
    hideDatePicker() {
      if (this.$refs.datePicker) {
        // works for most custom date pickers
        this.$refs.datePicker.handleScroll?.();
        this.$refs.datePicker.blur?.();
      }
    },
    updatePage(page) {
      if (page == this.page) return
      this.page = page
      this.loading = true
      this.getWorkOrderListing({
        "search": this.search,
        "limit": this.limit,
        "page": this.page,
        date_range: `${this.selectedDate[0]} - ${this.selectedDate[1]}`
      });
    },
    onActionClicked(data, option) {

      if (option == 'Details') {
        this.$router.push({
          "name": "workOrdersDetail",
          params: {
            id: data.appointment_id
          }
        })
      } else if (option == 'Cancel') {
        this.$refs.cancelClaimModal.show(data.appointment_id);
      } else if (option == 'Reschedule Appointment') {
        this.$refs.resheduleApptModal.show(data.appointment_id, data.appointment_date_time);
      }

    },
    onSearch() {
      clearTimeout(this.debounceTimer);
      // Start new debounce timer

      this.page = 1
      this.debounceTimer = setTimeout(() => {
        if (this.search.length == 0 || this.search.trim().length > 0) {
          this.loading = true
          this.getWorkOrderListing({
            "search": this.search,
            "limit": this.limit,
            "page": this.page,
            date_range: `${this.selectedDate[0]} - ${this.selectedDate[1]}`
          });
        }
      }, 1000); // 1200ms delay
    },
    onClearSearch() {
      clearTimeout(this.debounceTimer);
      this.page = 1
      this.search = ''
      this.loading = true
      this.getWorkOrderListing({
        "search": this.search,
        "limit": this.limit,
        "page": this.page,
        date_range: `${this.selectedDate[0]} - ${this.selectedDate[1]}`
      });

    },
    adjustPlanModalHeight() {
      const modalContent = this.$refs.scrollBox;
      if (modalContent) {
        const vh = window.innerHeight;
        const vw = window.innerWidth;
        let maxHeight;
        if (vw < 300) {
          maxHeight = vh * 0.5 - 40;
        } else if (vw < 768) {
          maxHeight = vh * 0.8 - 50;
        } else if (vw < 991) {
          maxHeight = vh * 0.8 - 50;
        } else if (vw < 1440) {
          maxHeight = vh * 0.8 - 50;
        }
        else {
          maxHeight = vh * 0.8 - 40;
        }
        modalContent.style.maxHeight = `${maxHeight}px`;
        modalContent.style.overflowY = 'auto';
      }
    },
    onLimitChange(newLimit) {
      this.limit = newLimit;
      this.page = 1;
      this.loading = true;
      this.getWorkOrderListing({
        search: this.search,
        limit: this.limit,
        page: this.page,
        date_range: `${this.selectedDate[0]} - ${this.selectedDate[1]}`
      });
    },
    setTableHeaders() {
      this.tableHeaders = [
        this.getTableHeaderObject("Job ID", "job_number", "job_number", "", "1"),
        this.getTableHeaderObject("Technician", "assignee_name", "assignee_name", "", "1"),
        // this.getTableHeaderObject("Address", "service_address", "service_address", "", "1"),
        this.getTableHeaderObject("Trade", "trade_name", "trade_name", "", "1"),
        this.getTableHeaderObject("Service", "service_name", "service_name", "", "1"),
        this.getTableHeaderObject("Claim Requested", "requested_date_time", "requested_date_time", "", "1"),
        this.getTableHeaderObject("Visit Shedule", "appointment_date_time", "appointment_date_time", "", "1"),
        this.getTableHeaderObject("Status", "progress_status_text", "progress_status_text", "", "1"),
        this.getTableHeaderObject("Action", "action", "action", "", "0"),
      ]
      this.setSort()
    },
    getTableHeaderObject(title, data_value, sort_column, sort_direction, sort_applicable, isHeaderToolTipShow = 0, tooltip_text = '') {
      return {
        title: title,
        data_value: data_value,
        sort_column: sort_column,
        sort_direction: sort_direction,
        sort_applicable: sort_applicable,
        isHeaderToolTipShow: isHeaderToolTipShow,
        tooltip_text: tooltip_text
      }
    },
    setSort() {
      this.tableHeaders.map(obj => {
        if (obj.sort_column == this.selectedSort.column) {
          obj.sort_direction = this.selectedSort.direction;
        } else {
          obj.sort_direction = "";
        }
      });
    },
    sortClicked(item) {
      if (item.sort_applicable == '1') {
        this.page = 1
        if (item.sort_column == this.selectedSort.column) {
          this.selectedSort.direction = item.sort_direction == "DESC" ? "ASC" : "DESC"
          item.sort_direction = this.selectedSort.direction
        } else {
          this.tableHeaders.map(obj => {
            obj.sort_direction = "";
          });
          this.selectedSort.column = item.sort_column
          this.selectedSort.direction = item.sort_direction == "DESC" ? "ASC" : "DESC"
          item.sort_direction = this.selectedSort.direction
        }
        this.getWorkOrderListing({
          search: this.search,
          limit: this.limit,
          page: this.page,
          'sort[column]': this.selectedSort.column,
          'sort[direction]': this.selectedSort.direction,
          date_range: `${this.selectedDate[0]} - ${this.selectedDate[1]}`
        })
      }
    },
  },
};
</script>

<style>
.daterangepicker {
  z-index: 99;
}
</style>